//Models
PJQ.models.invoicing.BillingPeriodSettings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'billingperiods'
            },
            {
                endpoint: 'settings'
            }
        ]);
    },
    parse: function (model) {
        if (!model)
            return model;

        this.billingPeriods = new PJQ.collections.budget.BillingPeriods(model.billingPeriods);

        return model;
    },
});

PJQ.models.invoicing.BillingPeriod = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'billingperiods',
                value: this.id
            }
        ]);
    },
});

//Collections
PJQ.collections.invoicing.BillingPeriods = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.BillingPeriod
});